export const getSafe = (obj, path, defaultValue) => {
  const keys = path.replace(/\[(\d+)\]/g, '.$1').split('.');

  return keys.reduce((acc, key) => {
    if (Array.isArray(acc) && !Number.isNaN(key)) {
      return acc[key] !== undefined ? acc[key] : defaultValue;
    } if (acc && acc[key] !== undefined) {
      return acc[key];
    }
    return defaultValue;
  }, obj);
};
